import React from 'react'
import { ReactComponent as PaperClip } from '../../shared/assets/paperclip.svg'
import styles from './Intro.module.css'

const Intro = props => (
  <div className={styles.base}>
    <div className={styles.header}>
      <div className={styles.headerTitle}>Test Je Kennis!</div>
    </div>

    <div>
      <div className={styles.info}>
        <div className={styles.infoRules}>
          <div className={styles.paperclip}>
            <PaperClip />
          </div>

          <div>
            <div>Na afloop van de eindtoets kun je alle vragen en antwoorden inzien, om te ontdekken wat er (minder) goed ging. We geven dan ook aan welke hoofdstukken je het beste nog even kunt doornemen.</div>
          </div>
        </div>

        <div className={styles.infoText}>
          <div>
            <div>Na afloop van de eindtoets kun je alle vragen en antwoorden inzien, om te ontdekken wat er (minder) goed ging. We geven dan ook aan welke hoofdstukken je het beste nog even kunt doornemen.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Intro
